import { render, staticRenderFns } from "./provincialBfjl.vue?vue&type=template&id=5a4ccb7b&"
import script from "./provincialBfjl.vue?vue&type=script&lang=js&"
export * from "./provincialBfjl.vue?vue&type=script&lang=js&"
import style0 from "./provincialBfjl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports